import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/erlang/cdf';
import __var_2__ from '@stdlib/stats/base/dists/erlang/ctor';
import __var_3__ from '@stdlib/stats/base/dists/erlang/entropy';
import __var_4__ from '@stdlib/stats/base/dists/erlang/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/erlang/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/erlang/mean';
import __var_7__ from '@stdlib/stats/base/dists/erlang/mgf';
import __var_8__ from '@stdlib/stats/base/dists/erlang/mode';
import __var_9__ from '@stdlib/stats/base/dists/erlang/pdf';
import __var_10__ from '@stdlib/stats/base/dists/erlang/quantile';
import __var_11__ from '@stdlib/stats/base/dists/erlang/skewness';
import __var_12__ from '@stdlib/stats/base/dists/erlang/stdev';
import __var_13__ from '@stdlib/stats/base/dists/erlang/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace erlang
*/
var erlang = {};

/**
* @name cdf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/cdf}
*/
setReadOnly( erlang, 'cdf', __var_1__);

/**
* @name Erlang
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/ctor}
*/
setReadOnly( erlang, 'Erlang', __var_2__);

/**
* @name entropy
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/entropy}
*/
setReadOnly( erlang, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/kurtosis}
*/
setReadOnly( erlang, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/logpdf}
*/
setReadOnly( erlang, 'logpdf', __var_5__);

/**
* @name mean
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/mean}
*/
setReadOnly( erlang, 'mean', __var_6__);

/**
* @name mgf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/mgf}
*/
setReadOnly( erlang, 'mgf', __var_7__);

/**
* @name mode
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/mode}
*/
setReadOnly( erlang, 'mode', __var_8__);

/**
* @name pdf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/pdf}
*/
setReadOnly( erlang, 'pdf', __var_9__);

/**
* @name quantile
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/quantile}
*/
setReadOnly( erlang, 'quantile', __var_10__);

/**
* @name skewness
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/skewness}
*/
setReadOnly( erlang, 'skewness', __var_11__);

/**
* @name stdev
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/stdev}
*/
setReadOnly( erlang, 'stdev', __var_12__);

/**
* @name variance
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/variance}
*/
setReadOnly( erlang, 'variance', __var_13__);


// EXPORTS //
export default erlang;

export { __var_1__ as cdf, __var_2__ as Erlang, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as mgf, __var_8__ as mode, __var_9__ as pdf, __var_10__ as quantile, __var_11__ as skewness, __var_12__ as stdev, __var_13__ as variance};